import React, { PureComponent } from 'react';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import VehicleChauffeursView from '@components/vehicle/VehicleChauffeursView';

import * as navigationActions from '@actions/navigationActions';
import * as vehicleActions from '@actions/vehicleActions';

class VehicleChauffeursContainer extends PureComponent {
  render() {
    const { ...props } = this.props;
    return <VehicleChauffeursView {...props} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
    ...state.vehicle,
    ...ownProps,
    dateFormat: state.settings?.settings?.user?.language?.dateFormat || "DD/MM/YYYY",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicle: (id) => dispatch(vehicleActions.getVehicle(id)),
    getVehicleChauffeurs: (id, from, to) =>
      dispatch(vehicleActions.getVehicleChauffeurs(id, from, to)),

    vehicleDetachChauffeur: (id, action) =>
      dispatch(vehicleActions.vehicleDetachChauffeur(id, action)),

    addToStack: (component) =>
      dispatch(navigationActions.addToStack(component)),
    popStack: () => dispatch(navigationActions.popStack()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translation')(VehicleChauffeursContainer));
